import { render, staticRenderFns } from "./EmployerTrainingDetail.vue?vue&type=template&id=28d2edb0&"
import script from "./EmployerTrainingDetail.vue?vue&type=script&lang=ts&"
export * from "./EmployerTrainingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports